export default __webpack_public_path__ + "static/media/logo.ca8e1a45.png";